import React from "react";
import { FiCheckCircle, FiAlertCircle, FiInfo, FiX } from "react-icons/fi";

const styles = {
  success: {
    container: "border-[#e0d8c3] bg-[#e0d8c3]/20 text-[#000000]",
    icon: <FiCheckCircle size={20} />,
  },
  error: {
    container: "border-red-500 bg-red-500/10 text-red-600",
    icon: <FiAlertCircle size={20} />,
  },
  info: {
    container: "border-[#a6a6a6]/50 bg-[#a6a6a6]/10 text-[#000000]",
    icon: <FiInfo size={20} />,
  },
};

const Notification = ({
  type = "info",
  message,
  onClose,
}) => {
  if (!message) return null;

  return (
    <div
      className={`flex items-start gap-3 rounded-xl border p-4 shadow-sm ${styles[type]?.container ?? styles.info.container}`}
    >
      <div className="mt-0.5 shrink-0">{styles[type]?.icon ?? styles.info.icon}</div>

      <div className="flex-1 text-sm font-medium">
        {message}
      </div>

      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className="shrink-0 text-[#a6a6a6] hover:text-[#000000] transition"
          aria-label="Mbyll"
        >
          <FiX size={16} />
        </button>
      )}
    </div>
  );
};

export default Notification;
